import React, { FunctionComponent, useCallback, useMemo } from "react"
import { useHistory, useRouteMatch } from "react-router"
import { Link } from "react-router-dom"
import DotButton from "../../components/Buttons/DotButton"
import { eImageVersions, iImageVersions } from "../../definitions/Image"
import { iUrlParams } from "../../definitions/interfaces"
import { useImage } from "../../hooks/useImage"
import { useImageUrl } from "../../hooks/useImageUrl"
import { useSelector } from "../../store"
import { getSpaceRoutes } from "./inspector/routes"

interface iProps {
  coverVersions?: iImageVersions
  cover?: string
  title: string
  handleDelete?: () => void
  handleSubmit?: () => void
  submitDeleteText: string
  submitText?: string
  isLoading?: boolean
  type?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  access?: any
}

const SpaceHeader: FunctionComponent<iProps> = ({
  cover = "",
  title,
  handleSubmit,
  handleDelete,
  submitDeleteText,
  submitText = "Update",
  isLoading = false,
  access,
}) => {
  const match = useRouteMatch<iUrlParams>()
  const history = useHistory()
  const { user } = useSelector(({ user }) => ({
    user,
  }))

  const { permissions } = user

  const { file } = useImage({
    fileId: cover,
    fileCollection: "Files_SpacePosters",
  })

  const coverImage =
    file && useImageUrl(eImageVersions.XLWRegular, file.versions)

  const navRoutes = useMemo(
    () => getSpaceRoutes({ urlPrefix: match.url, access, permissions, user }),
    [match.url],
  )

  const handleHisoryBack = useCallback((e: React.SyntheticEvent) => {
    e.preventDefault()
    history.goBack()
  }, [])

  return (
    <div className="inspector-header">
      <div className="inspector-cover-wrap">
        <div
          className="inspector-cover"
          style={{ backgroundImage: `url(${coverImage})` }}
        ></div>
        <div className="inspector-cover-overlay">
          <div className="inspector-headline">
            <Link to={"#"} onClick={handleHisoryBack}>
              <i className="fa fa-chevron-left"></i>
              <span>Back</span>
            </Link>

            <div className="d-flex">
              {access && access.canDelete && (
                <DotButton
                  isLoading={isLoading}
                  className={`btn-red submit-button`}
                  text={submitDeleteText}
                  onClick={handleDelete}
                  type="button"
                >
                  {submitDeleteText}
                </DotButton>
              )}
              {access && access.canEdit && (
                <DotButton
                  className={`btn-blue submit-button`}
                  text={submitText}
                  isLoading={isLoading}
                  onClick={handleSubmit}
                  type="button"
                >
                  {submitText}
                </DotButton>
              )}
            </div>
          </div>
          <h1 className="inspector-title">{title}</h1>
        </div>
      </div>
      <div className="inspector-navigation">
        <ul>
          {navRoutes.map((n, i) => {
            return (
              <li
                key={i}
                className={
                  history.location.pathname === n.route ? "active" : ""
                }
              >
                <Link to={n.route} replace>
                  <span>{n.title}</span>
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default SpaceHeader
